import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { translationChunksConfig } from "@spartacus/assets";
import { I18nModule, ConfigModule, CmsConfig, provideConfig } from "@spartacus/core";
import { MediaModule } from "@spartacus/storefront";
import { CustomProdPgModule } from "../custom-prod-pg/custom-prod-pg.module";
import { NoMouseScrollModule } from "../shared/directives/no-mouse-scroll/no-mouse-scroll.module";
import { CustomPdpComponent } from "./custom-pdp/custom-pdp.component";
// import { SlickCarouselModule } from 'ngx-slick-carousel';

@NgModule({
  declarations: [CustomPdpComponent],

  imports: [
    CommonModule,
    MediaModule,
    NgSelectModule,
    I18nModule,
    // SlickCarouselModule,
    NgbModule,
    CustomProdPgModule,
    FormsModule,
    NoMouseScrollModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductIntroComponent: {
          component: CustomPdpComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class CustomPdpModule { }
